import { Box, Button, Container, createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import '../App.scss'
import constants from "../Constants";
const theme = createTheme();

const InvitePage = () => {
    return (
        <Box className="host-page" sx={{
            '@media only screen and (max-width: 600px)': {
                backgroundImage: 'url("/BG_Sixtema_Mobile.jpg")',
                backgroundSize: 'cover'
            },
            '@media only screen and (min-width: 601px)': {
                backgroundImage: 'url("/BG_Sixtema_Desktop.jpg")',
                backgroundSize: 'cover'
            },
        }}>
            <ThemeProvider theme={theme}>
                <Container component="main" maxWidth="sm" sx={{ display: 'flex' }}>
                    <CssBaseline />
                    <Box className="invite-box">
                        <img src="/MySixtema.svg" alt='MySixtema' height={128} />
                        <Button variant="contained" sx={{ marginTop: 6, padding: '0px 16px', fontSize: '1.4rem', textTransform: 'none' }} href={constants.loginUrl}>Accedi</Button>
                    </Box>
                </Container>
            </ThemeProvider>
        </Box>
    );
}

export default InvitePage